const shouldRun = require("common/should-run");
const WithdrawExperimentException = require("common-core/withdraw-experiment-exception");

/**
 * This is your opportunity to do stuff synchronously as the HEAD loads.
 * <opportunity>
 */

/**
 * Warning: attempting to use jQuery before the "jquery-requirement" check in shouldRun won't work.
 */

shouldRun().then(() => {
    require("treatment/sample/sample-treatment").init();
}).catch(e => {
    if (!(e instanceof WithdrawExperimentException)) { throw e; }
});



// WEBPACK FOOTER //
// ./src/control/jira.js